import useProductActionsStore from '../../../../../stores/ProductActionsStore/productActions.store';
import {
  ShopByOutcome,
  ShopByResultOutput,
} from '../../../../products/repositories/types/productActions.types';
import { OrderProduct } from '../../orderProducts.types';

export const notifyAppliedProductsAdded = (orderProducts: OrderProduct[]) => {
  const { setOrderProducts, openProductNotification } = useProductActionsStore.getState();

  setOrderProducts(orderProducts);
  openProductNotification({
    productAdd: true,
    productAlready: false,
    isOrderProductsApplied: true,
  });
};

const useProductAddedNotification = () => {
  const notifyOutcome = (data: ShopByResultOutput) => {
    if (data.outcome !== ShopByOutcome.ADDED || !data.orderProducts?.length) {
      return;
    }

    notifyAppliedProductsAdded(data.orderProducts);
  };

  return { notifyOutcome };
};

export default useProductAddedNotification;
